import React, { useEffect, useState } from "react";
import { environment } from "environment/environment";
import useNiftyWebsocket from "service/websocket/NiftyWebsocketApi";
import "./Dashboard.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../common/AuthContext";

const Dashboard = () => {
  const { options } = useNiftyWebsocket(environment.niftyWebsocketUrl);
  const [niftyIndexLiveData, setNiftyIndexLiveData] = useState(null);
  const [bankniftyIndexLiveData, setBankniftyIndexLiveData] = useState(null);
  const [finniftyIndexLiveData, setFinniftyIndexLiveData] = useState(null);
  const [midcpniftyIndexLiveData, setMidcpniftyIndexLiveData] = useState(null);
   const { user,userPlan, logout, isLoading } = useAuth();
  const navigate = useNavigate();
  const [userPlanByUserId, setUserPlanByUserId] = useState(null);

  // ✅ Redirect to login if not logged in
  useEffect(() => {
    if (!isLoading && !user) {
      navigate("/login");
    }
  }, [user, isLoading, navigate]);

  // ✅ Fetch user plan after user info is loaded
  useEffect(() => {
    const fetchUserPlan = async (userId) => {
      if (!userId) return;

      try {
        const response = await fetch(
          `${environment.baseUrl}/user-pan/get-user-plain-by-user-id?userId=${userId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );

        const res = await response.json();

        if (res.status && res.data) {
           setUserPlanByUserId(res.data);
          console.log("Fetched userPlanByUserId => ", res.data);
        }
      } catch (error) {
        console.error("Error fetching user plan:", error);
      }
    };

    if (user?.userId) {
      fetchUserPlan(user.userId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]); // Runs only when user becomes available

  // ✅ Log the updated userPlanByUserId when state actually changes
  useEffect(() => {
    if (userPlanByUserId) {
      console.log("Updated userPlanByUserId =>", userPlanByUserId);
    }
  }, [userPlanByUserId]);

  // ✅ Handle live data from websocket
  useEffect(() => {
    if (!options) return;

    setNiftyIndexLiveData(options["NSE:NIFTY"]?.indexLiveDataModel || null);
    setBankniftyIndexLiveData(options["NSE:BANKNIFTY"]?.indexLiveDataModel || null);
    setFinniftyIndexLiveData(options["NSE:FINNIFTY"]?.indexLiveDataModel || null);
    setMidcpniftyIndexLiveData(options["NSE:MIDCPNIFTY"]?.indexLiveDataModel || null);
  }, [options]);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  if (isLoading) return <div className="loading">Loading...</div>;
  if (!user) return null;
  
  return (
    <div className="dashboard-container">
      <div className="welcome-banner fade-in">
        <div>
          <h2 className="welcome-title">
            Welcome back, {user?.userName || "User"}!
          </h2>
          <p className="welcome-text">
            Ready to continue your journey? Let’s see what’s new today.
          </p>
        </div>
      </div>

      <div className="info-card-top">
        <section className="card">
          <h2>User Details</h2>
          <div className="detail-row"><span className="label">User ID:</span><span className="value">{user?.userId || "--"}</span></div>
          <div className="detail-row"><span className="label">Name:</span><span className="value">{user?.userName || "--"}</span></div>
          <div className="detail-row"><span className="label">Mobile:</span><span className="value">{user?.mobileNumber || "--"}</span></div>
          <div className="detail-row"><span className="label">Email:</span><span className="value">{user?.email || "--"}</span></div>
          <div className="detail-row"><span className="label">Post:</span><span className="value">Admin</span></div>
        </section>

        <section className="card">
          <h2>Plan & Validity</h2>
          <div className="detail-row"><span className="label">Plan:</span><span className="value">{userPlan?.planName || "--"}</span></div>
          <div className="detail-row"><span className="label">Plan Validity:</span><span className="value">{userPlan?.planValidity || "--"}</span></div>
          <div className="detail-row"><span className="label">Days Left:</span><span className="value">{userPlan?.daysLeft || "--"}</span></div>
          <div className="detail-row"><span className="label">Start:</span><span className="value">{userPlan?.subscribeDateStart || "--"}</span></div>
          <div className="detail-row"><span className="label">End:</span><span className="value">{userPlan?.subscribeDateEnd || "--"}</span></div>
        </section>

        <section className="card">
          <h2>Performance</h2>
          <div className="detail-row"><span className="label">Total Trades:</span><span className="value">248</span></div>
          <div className="detail-row"><span className="label">Win Rate:</span><span className="value">78%</span></div>
          <div className="detail-row"><span className="label">Profit:</span><span className="value">₹1,24,500</span></div>
        </section>
      </div>

        {/* ================== Bottom Info Cards row -1 ================== */}
      <div className="info-card-bottom">
        <section className="card card-mouse-over"
          // onClick={() => navigateOptionChain("/nifty-option-data")}
          style={{ cursor: "pointer" }}>
          <div className="">
            <h2>
              {niftyIndexLiveData?.short_name || 'N/A'} &emsp;
              {niftyIndexLiveData?.ch || 'N/A'} &emsp;
              {niftyIndexLiveData?.chp || 'N/A'}%
            </h2>
          </div>
          <div className="detail-row">
            <span className="label">Prev Close:</span>
            <span className="value">{niftyIndexLiveData?.prev_close_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Spot Price:</span>
            <span className="value">{niftyIndexLiveData?.lp}</span>
          </div>
          <div className="detail-row">
            <span className="label">Open Price:</span>
            <span className="value">{niftyIndexLiveData?.open_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Close Price:</span>
            <span className="value">{niftyIndexLiveData?.lp}</span>
          </div>
          <div className="detail-row">
            <span className="label">High Price:</span>
            <span className="value">{niftyIndexLiveData?.high_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Low Price:</span>
            <span className="value">{niftyIndexLiveData?.low_price}</span>
          </div>
        </section>

       <section className="card">
          <div className="">
            <h2>
              {bankniftyIndexLiveData?.short_name || 'N/A'} &emsp;
              {bankniftyIndexLiveData?.ch || 'N/A'} &emsp;
              {bankniftyIndexLiveData?.chp || 'N/A'}%
            </h2>
          </div>
          <div className="detail-row">
            <span className="label">Prev Close:</span>
            <span className="value">{bankniftyIndexLiveData?.prev_close_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Spot Price:</span>
            <span className="value">{bankniftyIndexLiveData?.lp}</span>
          </div>
          <div className="detail-row">
            <span className="label">Open Price:</span>
            <span className="value">{bankniftyIndexLiveData?.open_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Close Price:</span>
            <span className="value">{bankniftyIndexLiveData?.lp}</span>
          </div>
          <div className="detail-row">
            <span className="label">High Price:</span>
            <span className="value">{bankniftyIndexLiveData?.high_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Low Price:</span>
            <span className="value">{bankniftyIndexLiveData?.low_price}</span>
          </div>
        </section>

        <section className="card">
          <div className="">
            <h2>
              {finniftyIndexLiveData?.short_name || 'N/A'} &emsp;
              {finniftyIndexLiveData?.ch || 'N/A'} &emsp;
              {finniftyIndexLiveData?.chp || 'N/A'}%
            </h2>
          </div>
          <div className="detail-row">
            <span className="label">Prev Close:</span>
            <span className="value">{finniftyIndexLiveData?.prev_close_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Spot Price:</span>
            <span className="value">{finniftyIndexLiveData?.lp}</span>
          </div>
          <div className="detail-row">
            <span className="label">Open Price:</span>
            <span className="value">{finniftyIndexLiveData?.open_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Close Price:</span>
            <span className="value">{finniftyIndexLiveData?.lp}</span>
          </div>
          <div className="detail-row">
            <span className="label">High Price:</span>
            <span className="value">{finniftyIndexLiveData?.high_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Low Price:</span>
            <span className="value">{finniftyIndexLiveData?.low_price}</span>
          </div>
        </section>
        
      </div>

      {/* ================== Bottom Info Cards row -2 ================== */}
      <div className="info-card-bottom">
        <section className="card">
          <div className="">
            <h2>
              {midcpniftyIndexLiveData?.short_name || 'N/A'} &emsp;
              {midcpniftyIndexLiveData?.ch || 'N/A'} &emsp;
              {midcpniftyIndexLiveData?.chp || 'N/A'}%
            </h2>
          </div>
          <div className="detail-row">
            <span className="label">Prev Close:</span>
            <span className="value">{midcpniftyIndexLiveData?.prev_close_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Spot Price:</span>
            <span className="value">{midcpniftyIndexLiveData?.lp}</span>
          </div>
          <div className="detail-row">
            <span className="label">Open Price:</span>
            <span className="value">{midcpniftyIndexLiveData?.open_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Close Price:</span>
            <span className="value">{midcpniftyIndexLiveData?.lp}</span>
          </div>
          <div className="detail-row">
            <span className="label">High Price:</span>
            <span className="value">{midcpniftyIndexLiveData?.high_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Low Price:</span>
            <span className="value">{midcpniftyIndexLiveData?.low_price}</span>
          </div>
        </section>

       <section className="card">
          <div className="">
            <h2>
              {bankniftyIndexLiveData?.short_name || 'N/A'} &emsp;
              {bankniftyIndexLiveData?.ch || 'N/A'} &emsp;
              {bankniftyIndexLiveData?.chp || 'N/A'}%
            </h2>
          </div>
          <div className="detail-row">
            <span className="label">Prev Close:</span>
            <span className="value">{bankniftyIndexLiveData?.prev_close_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Spot Price:</span>
            <span className="value">{bankniftyIndexLiveData?.lp}</span>
          </div>
          <div className="detail-row">
            <span className="label">Open Price:</span>
            <span className="value">{bankniftyIndexLiveData?.open_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Close Price:</span>
            <span className="value">{bankniftyIndexLiveData?.lp}</span>
          </div>
          <div className="detail-row">
            <span className="label">High Price:</span>
            <span className="value">{bankniftyIndexLiveData?.high_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Low Price:</span>
            <span className="value">{bankniftyIndexLiveData?.low_price}</span>
          </div>
        </section>

        {/* <section className="card">
          <div className="">
            <h2>
              {finniftyIndexLiveData?.original_name || 'N/A'} &emsp;
              {finniftyIndexLiveData?.ch || 'N/A'} &emsp;
              {finniftyIndexLiveData?.chp || 'N/A'}
            </h2>
          </div>
          <div className="detail-row">
            <span className="label">Prev Close:</span>
            <span className="value">{finniftyIndexLiveData?.prev_close_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Spot Price:</span>
            <span className="value">{finniftyIndexLiveData?.lp}</span>
          </div>
          <div className="detail-row">
            <span className="label">Open Price:</span>
            <span className="value">{finniftyIndexLiveData?.open_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Close Price:</span>
            <span className="value">{finniftyIndexLiveData?.lp}</span>
          </div>
          <div className="detail-row">
            <span className="label">High Price:</span>
            <span className="value">{finniftyIndexLiveData?.high_price}</span>
          </div>
          <div className="detail-row">
            <span className="label">Low Price:</span>
            <span className="value">{finniftyIndexLiveData?.low_price}</span>
          </div>
        </section> */}
        
      </div>
    </div>
  );
};

export default Dashboard;
